import { Directive, inject, Input } from '@angular/core';

import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';

import { BnToastrService } from '@bn/shared/toastr';

import { ModalState } from '../models/modal-state.model';

@Directive()
export abstract class AbstractModalDirective {
  @Input()
  public styleClass = ''; // NOTE: 'modal-lg'

  @Input()
  public dialogId?: string; // NOTE: if we plan to have multiple modals open at the same time

  @Input()
  public data!: ModalState;

  public bsModalRef = inject(BsModalRef);
  public readonly toastr = inject(BnToastrService);
  protected modalService = inject(BsModalService);

  getInputState(): ModalOptions<ModalState> {
    return {
      initialState: this.data,
      ...(this.dialogId?.length ? { id: this.dialogId } : {}),
      ...(this.styleClass?.length ? { class: this.styleClass } : {}),
    };
  }

  abstract clicked(event: Event): void;
}
